import React, { useEffect, useRef, useState } from 'react';
import { Card, Form, Button, Row, Col, DatePicker, Spin, Table, Switch } from 'antd';
import { wtGetFromLocalStorage } from 'src/helpers/commons/LocalStorage';
import BaseListing from 'src/BaseListings';
import WidgetBranchSelector from 'src/widgets/Selectors/WidgetBranchSelector'
import { lzNotifyErrorMessageFromResult } from 'src/helpers/commons/notifications';
import { wtApiCall, wtApiPostWithContentTypeHandling } from 'src/helpers/commons/ApiWrapper';
import WidgetPartySelector from 'src/widgets/Selectors/WidgetPartySelector';
import { wtFormatRoundedValue } from 'src/helpers/commons/utils';
import { useDownloadExcel } from 'react-export-table-to-excel'
import Loading from 'src/helpers/commons/loader'

const DebtorsReport = () => {
  const Base = new BaseListing('jv_report');
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const [branchId, setBranchId] = useState(0);
  const [branchName, setBranchName] = useState('');
  const [JVData, setJVData] = useState([]);
  const branches = wtGetFromLocalStorage("branches");
  const [parties, setParties] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null); // 🔥 Single date
  const [PartyName, setPartyName] = useState('');
  const [PartyId, setPartyId] = useState(null);
  const tableRef = useRef(null)

  const changeValues = (key, val) => {
    setJVData([]);
    if (key === 'branch_id') {
      setBranchId(val.value);
      setBranchName(val.label);
    }
    if (key === 'party_id') {
      setPartyId(val);
      if (val === null) {
        setPartyName('');
      }
    }
  };

  const getReportData = () => {
    if (!selectedDate) {
      lzNotifyErrorMessageFromResult("Please select date");
      return;
    }
    setIsLoading(true);
    wtApiCall(
      'reports/debtors_report',
      {
        branch_id: branchId,
        date: selectedDate.format('YYYY-MM-DD'),  // 🔥 single date
        party_id: PartyId
      },
      'get',
      (response) => {
        setJVData(response.data);
        setIsLoading(false);
      },
      (error) => {
        lzNotifyErrorMessageFromResult(error);
        setIsLoading(false);
      }
    );
  };
  useEffect(() => {
    Base.dropdownData('parties', {}, [setParties], 1);
  }, []);
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: 'Employee Data Report',
    sheet: 'Sheet',
  })

  const columns = [
    {
      title: 'Sr',
      key: 'sr',
      width: 40,
      fixed: 'left',
      render: (_, __, index) => <span style={{ fontSize: '16px', fontWeight: 400 }}>{index + 1}</span>,
    },
    {
      title: 'Party Name',
      dataIndex: 'party_name',
      key: 'party_name',
      width: 340,
      render: (_, record) => (
        <span style={{ fontSize: '16px', fontWeight: 400 }}>
          {`${record.party_code ?? '-'} - ${record.party_name ?? '-'}`}
        </span>
      ),
    },
    {
      title: 'Party NTN/CNIC',
      dataIndex: 'party_ntn',
      key: 'party_ntn',
      width: 110,
      render: (_, record) => (
        <span style={{ fontSize: '16px', fontWeight: 400 }}>
          {`${record.party_ntn ?? '-'}${record.party_cnic ? ' / ' + record.party_cnic : '-'}`}
        </span>
      ),
    },
    {
      title: 'Address',
      dataIndex: 'party_address',
      key: 'party_address',
      width: 150,
      render: (_, record) => {
        const address = record.party_address ?? '-';
        const city = record.party_city ?? '-';
        return (
          <span style={{ fontSize: '16px', fontWeight: 400 }}>
            {city ? `${address} (${city})` : address}
          </span>
        );
      },
    },
    {
      title: 'Balance Amount',
      dataIndex: 'total_amount',
      key: 'total_amount',
      width: 150,
      align: 'center',
      render: (value) => (
        <span
          style={{
            color: '#000000',
            fontSize: '16px',
            fontWeight: 400,
            display: 'inline-block',
            width: '100%',
            textAlign: 'center',
          }}
        >
          {wtFormatRoundedValue(value, '')}
        </span>
      ),
    },
  ];


  return (
    <div className='container-fluid' style={{ padding: "1em", backgroundColor: "white", minHeight: "100vh", fontFamily: "Helvetica" }}>
      <Form
        layout={'vertical'}
        form={form}
        onFinish={getReportData}
        style={{ maxWidth: "100%", margin: '0 auto' }}
      >
        <Card style={{ width: "100%" }} title={<span style={{ fontSize: '26px', marginLeft: "45%" }}>Debtors Report</span>}>
          <Row gutter={[24, 24]}>

            {/* 🔥 Single DatePicker */}
            <Col xs={15} sm={10} md={5}>
              <label>Date : *</label>
              <DatePicker
                onChange={(value) => setSelectedDate(value)}
                style={{ width: '100%', height: 35 }}
                value={selectedDate}
              />
            </Col>

            <Col xs={15} sm={10} md={4}>
              <label>Branch:</label>
              <WidgetBranchSelector
                value={branchId}
                displayValue={branchName}
                branches={branches}
                placeholder="Select Branch"
                onChange={(values) => changeValues('branch_id', values)}
                showCloudIcon={false}
              />
            </Col>

            <Col xs={15} sm={10} md={6}>
              <label>Party</label>
              <WidgetPartySelector
                onChange={(value) => changeValues('party_id', value)}
                parties={parties}
                displayValue={PartyName}
                value={PartyId}
              />
            </Col>

            <Col xs={12} sm={8} md={5}>
              <Button style={{ marginTop: 30, marginRight: 5 }} type="primary" htmlType="submit" disabled={isLoading}>
                Search
              </Button>
              <Button
                type="primary"
                style={{
                  marginBottom: '20px',
                  marginTop: '20px',
                  marginLeft: '1%',
                  backgroundColor: '#52c41a',
                  borderColor: '#52c41a',
                  color: '#fff',
                }}
                onClick={onDownload}
              >
                Export
              </Button>
            </Col>
          </Row>
        </Card>
      </Form>

      <Card style={{ marginTop: 30 }}>
        <table className="table table-bordered data-table" ref={tableRef}>
          {isLoading ? (
            Loading
          ) : (
            <>
              {JVData.length > 0 ? (
                <Table
                  columns={columns}
                  dataSource={JVData}
                  rowKey="id"
                  pagination={false}
                  bordered
                  sticky
                  summary={() => {
                    let totalAmount = JVData.reduce((sum, row) => sum + Number(row.total_amount || 0), 0);

                    return (
                      <Table.Summary.Row>
                        <Table.Summary.Cell index={0} colSpan={4}>
                          <b>Total</b>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={4} align="center">
                          <span
                            style={{
                              color: '#000000',
                              fontSize: '16px',
                              fontWeight: 700,
                              display: 'inline-block',
                              width: '100%',
                              textAlign: 'center',
                            }}
                          >
                            {totalAmount.toLocaleString()}
                          </span>
                        </Table.Summary.Cell>
                      </Table.Summary.Row>
                    );
                  }}
                />
              ) : (
                <center style={{ fontSize: '19px', fontWeight: 'bold' }}>No record to show...</center>
              )}
            </>
          )}
        </table>


      </Card>
    </div>
  );
};

export default DebtorsReport;
